module.exports = {
lines:[
    {
        chunks: {
            line_0_begin: {
                x: 16,
                y: 385
            },
            line_0_cell_0: {
                x: 62,
                y: 385
            },
            line_0_cell_1: {
                x: 244,
                y: 385
            },
            line_0_cell_2: {
                x: 426,
                y: 385
            },
            line_0_cell_3: {
                x: 608,
                y: 385
            },
            line_0_cell_4: {
                x: 790,
                y: 385
            },
            line_0_gap_0: {
                x: 231,
                y: 385
            },
            line_0_gap_1: {
                x: 413,
                y: 385
            },
            line_0_gap_2: {
                x: 595,
                y: 385
            },
            line_0_gap_3: {
                x: 777,
                y: 385
            }
        },
        trajectory: [
            1,
            1,
            1,
            1,
            1
        ]
    },
    {
        chunks: {
            line_1_begin: {
                x: 16,
                y: 257
            },
            line_1_cell_0: {
                x: 62,
                y: 257
            },
            line_1_cell_1: {
                x: 244,
                y: 257
            },
            line_1_cell_2: {
                x: 426,
                y: 257
            },
            line_1_cell_3: {
                x: 608,
                y: 257
            },
            line_1_cell_4: {
                x: 790,
                y: 257
            },
            line_1_gap_0: {
                x: 231,
                y: 257
            },
            line_1_gap_1: {
                x: 413,
                y: 257
            },
            line_1_gap_2: {
                x: 595,
                y: 257
            },
            line_1_gap_3: {
                x: 777,
                y: 257
            }
        },
        trajectory: [
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        chunks: {
            line_2_begin: {
                x: 16,
                y: 513
            },
            line_2_cell_0: {
                x: 62,
                y: 513
            },
            line_2_cell_1: {
                x: 244,
                y: 513
            },
            line_2_cell_2: {
                x: 426,
                y: 513
            },
            line_2_cell_3: {
                x: 608,
                y: 513
            },
            line_2_cell_4: {
                x: 790,
                y: 513
            },
            line_2_gap_0: {
                x: 231,
                y: 513
            },
            line_2_gap_1: {
                x: 413,
                y: 513
            },
            line_2_gap_2: {
                x: 595,
                y: 513
            },
            line_2_gap_3: {
                x: 777,
                y: 513
            }
        },
        trajectory: [
            2,
            2,
            2,
            2,
            2
        ]
    },
    {
        chunks: {
            line_3_begin: {
                x: 15,
                y: 192
            },
            line_3_cell_0: {
                x: 62,
                y: 192
            },
            line_3_cell_1: {
                x: 244,
                y: 301
            },
            line_3_cell_2: {
                x: 426,
                y: 509
            },
            line_3_cell_3: {
                x: 635,
                y: 306
            },
            line_3_cell_4: {
                x: 790,
                y: 192
            },
            line_3_end: {
                x: 959,
                y: 192
            },
            line_3_gap_0: {
                x: 231,
                y: 287
            },
            line_3_gap_1: {
                x: 382,
                y: 466
            },
            line_3_gap_2: {
                x: 595,
                y: 466
            },
            line_3_gap_3: {
                x: 777,
                y: 291
            }
        },
        trajectory: [
            0,
            1,
            2,
            1,
            0
        ]
    },
    {
        chunks: {
            line_4_begin: {
                x: 15,
                y: 576
            },
            line_4_cell_0: {
                x: 62,
                y: 480
            },
            line_4_cell_1: {
                x: 244,
                y: 297
            },
            line_4_cell_2: {
                x: 426,
                y: 160
            },
            line_4_cell_3: {
                x: 627,
                y: 297
            },
            line_4_cell_4: {
                x: 790,
                y: 476
            },
            line_4_end: {
                x: 959,
                y: 576
            },
            line_4_gap_0: {
                x: 231,
                y: 464
            },
            line_4_gap_1: {
                x: 391,
                y: 258
            },
            line_4_gap_2: {
                x: 595,
                y: 254
            },
            line_4_gap_3: {
                x: 775,
                y: 461
            }
        },
        trajectory: [
            2,
            1,
            0,
            1,
            2
        ]
    },
    {
        chunks: {
            line_5_begin: {
                x: 15,
                y: 224
            },
            line_5_cell_0: {
                x: 62,
                y: 224
            },
            line_5_cell_1: {
                x: 244,
                y: 224
            },
            line_5_cell_2: {
                x: 431,
                y: 297
            },
            line_5_cell_3: {
                x: 608,
                y: 493
            },
            line_5_cell_4: {
                x: 790,
                y: 544
            },
            line_5_end: {
                x: 959,
                y: 544
            },
            line_5_gap_0: {
                x: 231,
                y: 224
            },
            line_5_gap_1: {
                x: 413,
                y: 270
            },
            line_5_gap_2: {
                x: 579,
                y: 466
            },
            line_5_gap_3: {
                x: 777,
                y: 544
            }
        },
        trajectory: [
            0,
            0,
            1,
            2,
            2
        ]
    },
    {
        chunks: {
            line_6_begin: {
                x: 15,
                y: 544
            },
            line_6_cell_0: {
                x: 62,
                y: 544
            },
            line_6_cell_1: {
                x: 244,
                y: 497
            },
            line_6_cell_2: {
                x: 439,
                y: 297
            },
            line_6_cell_3: {
                x: 608,
                y: 224
            },
            line_6_cell_4: {
                x: 790,
                y: 224
            },
            line_6_end: {
                x: 959,
                y: 224
            },
            line_6_gap_0: {
                x: 231,
                y: 544
            },
            line_6_gap_1: {
                x: 413,
                y: 466
            },
            line_6_gap_2: {
                x: 587,
                y: 274
            },
            line_6_gap_3: {
                x: 777,
                y: 224
            }
        },
        trajectory: [
            2,
            2,
            1,
            0,
            0
        ]
    },
    {
        chunks: {
            line_7_begin: {
                x: 15,
                y: 416
            },
            line_7_cell_0: {
                x: 62,
                y: 298
            },
            line_7_cell_1: {
                x: 244,
                y: 176
            },
            line_7_cell_2: {
                x: 446,
                y: 297
            },
            line_7_cell_3: {
                x: 608,
                y: 474
            },
            line_7_cell_4: {
                x: 829,
                y: 416
            },
            line_7_end: {
                x: 959,
                y: 416
            },
            line_7_gap_0: {
                x: 231,
                y: 285
            },
            line_7_gap_1: {
                x: 413,
                y: 252
            },
            line_7_gap_2: {
                x: 595,
                y: 459
            },
            line_7_gap_3: {
                x: 777,
                y: 466
            }
        },
        trajectory: [
            1,
            0,
            1,
            2,
            1
        ]
    },
    {
        chunks: {
            line_8_begin: {
                x: 15,
                y: 352
            },
            line_8_cell_0: {
                x: 62,
                y: 352
            },
            line_8_cell_1: {
                x: 244,
                y: 483
            },
            line_8_cell_2: {
                x: 455,
                y: 307
            },
            line_8_cell_3: {
                x: 608,
                y: 176
            },
            line_8_cell_4: {
                x: 819,
                y: 297
            },
            line_8_end: {
                x: 959,
                y: 352
            },
            line_8_gap_0: {
                x: 222,
                y: 466
            },
            line_8_gap_1: {
                x: 413,
                y: 466
            },
            line_8_gap_2: {
                x: 595,
                y: 293
            },
            line_8_gap_3: {
                x: 777,
                y: 246
            }
        },
        trajectory: [
            1,
            2,
            1,
            0,
            1
        ]
    },
    {
        chunks: {
            line_9_cell_0: {
                x: 63,
                y: 208
            },
            line_9_cell_1: {
                x: 275,
                y: 297
            },
            line_9_cell_2: {
                x: 426,
                y: 176
            },
            line_9_cell_3: {
                x: 614,
                y: 297
            },
            line_9_cell_4: {
                x: 790,
                y: 208
            },
            line_9_end: {
                x: 959,
                y: 208
            },
            line_9_gap_0: {
                x: 231,
                y: 243
            },
            line_9_gap_1: {
                x: 406,
                y: 275
            },
            line_9_gap_2: {
                x: 595,
                y: 269
            },
            line_9_gap_3: {
                x: 744,
                y: 247
            }
        },
        trajectory: [
            0,
            1,
            0,
            1,
            0
        ]
    },
    {
        chunks: {
            line_10_cell_0: {
                x: 63,
                y: 525
            },
            line_10_cell_1: {
                x: 284,
                y: 401
            },
            line_10_cell_2: {
                x: 426,
                y: 492
            },
            line_10_cell_3: {
                x: 622,
                y: 401
            },
            line_10_cell_4: {
                x: 790,
                y: 519
            },
            line_10_end: {
                x: 959,
                y: 560
            },
            line_10_gap_0: {
                x: 231,
                y: 466
            },
            line_10_gap_1: {
                x: 398,
                y: 466
            },
            line_10_gap_2: {
                x: 595,
                y: 466
            },
            line_10_gap_3: {
                x: 736,
                y: 466
            }
        },
        trajectory: [
            2,
            1,
            2,
            1,
            2
        ]
    },
    {
        chunks: {
            line_11_cell_0: {
                x: 63,
                y: 240
            },
            line_11_cell_1: {
                x: 267,
                y: 297
            },
            line_11_cell_2: {
                x: 426,
                y: 360
            },
            line_11_cell_3: {
                x: 608,
                y: 360
            },
            line_11_cell_4: {
                x: 790,
                y: 360
            },
            line_11_end: {
                x: 959,
                y: 360
            },
            line_11_gap_0: {
                x: 231,
                y: 251
            },
            line_11_gap_1: {
                x: 413,
                y: 360
            },
            line_11_gap_2: {
                x: 595,
                y: 360
            },
            line_11_gap_3: {
                x: 777,
                y: 360
            }
        },
        trajectory: [
            0,
            1,
            1,
            1,
            1
        ]
    },
    {
        chunks: {
            line_12_cell_0: {
                x: 63,
                y: 516
            },
            line_12_cell_1: {
                x: 276,
                y: 408
            },
            line_12_cell_2: {
                x: 426,
                y: 408
            },
            line_12_cell_3: {
                x: 608,
                y: 408
            },
            line_12_cell_4: {
                x: 790,
                y: 408
            },
            line_12_end: {
                x: 959,
                y: 408
            },
            line_12_gap_0: {
                x: 231,
                y: 466
            },
            line_12_gap_1: {
                x: 413,
                y: 408
            },
            line_12_gap_2: {
                x: 595,
                y: 408
            },
            line_12_gap_3: {
                x: 777,
                y: 408
            }
        },
        trajectory: [
            2,
            1,
            1,
            1,
            1
        ]
    },
    {
        chunks: {
            line_13_cell_0: {
                x: 63,
                y: 376
            },
            line_13_cell_1: {
                x: 244,
                y: 342
            },
            line_13_cell_2: {
                x: 451,
                y: 240
            },
            line_13_cell_3: {
                x: 608,
                y: 240
            },
            line_13_cell_4: {
                x: 790,
                y: 240
            },
            line_13_end: {
                x: 959,
                y: 240
            },
            line_13_gap_0: {
                x: 231,
                y: 376
            },
            line_13_gap_1: {
                x: 413,
                y: 298
            },
            line_13_gap_2: {
                x: 595,
                y: 240
            },
            line_13_gap_3: {
                x: 777,
                y: 240
            }
        },
        trajectory: [
            1,
            1,
            0,
            0,
            0
        ]
    },
    {
        chunks: {
            line_14_cell_0: {
                x: 63,
                y: 392
            },
            line_14_cell_1: {
                x: 244,
                y: 392
            },
            line_14_cell_2: {
                x: 442,
                y: 465
            },
            line_14_cell_3: {
                x: 608,
                y: 528
            },
            line_14_cell_4: {
                x: 790,
                y: 528
            },
            line_14_end: {
                x: 959,
                y: 528
            },
            line_14_gap_0: {
                x: 231,
                y: 392
            },
            line_14_gap_1: {
                x: 413,
                y: 424
            },
            line_14_gap_2: {
                x: 595,
                y: 528
            },
            line_14_gap_3: {
                x: 777,
                y: 528
            }
        },
        trajectory: [
            1,
            1,
            2,
            2,
            2
        ]
    },
    {
        chunks: {
            line_15_cell_0: {
                x: 63,
                y: 333
            },
            line_15_cell_1: {
                x: 262,
                y: 272
            },
            line_15_cell_2: {
                x: 426,
                y: 272
            },
            line_15_cell_3: {
                x: 608,
                y: 272
            },
            line_15_cell_4: {
                x: 790,
                y: 272
            },
            line_15_end: {
                x: 959,
                y: 272
            },
            line_15_gap_0: {
                x: 231,
                y: 298
            },
            line_15_gap_1: {
                x: 413,
                y: 272
            },
            line_15_gap_2: {
                x: 595,
                y: 272
            },
            line_15_gap_3: {
                x: 777,
                y: 272
            }
        },
        trajectory: [
            1,
            0,
            0,
            0,
            0
        ]
    },
    {
        chunks: {
            line_16_cell_0: {
                x: 63,
                y: 400
            },
            line_16_cell_1: {
                x: 253,
                y: 465
            },
            line_16_cell_2: {
                x: 426,
                y: 496
            },
            line_16_cell_3: {
                x: 608,
                y: 496
            },
            line_16_cell_4: {
                x: 790,
                y: 496
            },
            line_16_end: {
                x: 959,
                y: 496
            },
            line_16_gap_0: {
                x: 231,
                y: 434
            },
            line_16_gap_1: {
                x: 413,
                y: 496
            },
            line_16_gap_2: {
                x: 595,
                y: 496
            },
            line_16_gap_3: {
                x: 777,
                y: 496
            }
        },
        trajectory: [
            1,
            2,
            2,
            2,
            2
        ]
    },
    {
        chunks: {
            line_17_begin: {
                x: 15,
                y: 208
            },
            line_17_cell_0: {
                x: 62,
                y: 208
            },
            line_17_cell_1: {
                x: 244,
                y: 208
            },
            line_17_cell_2: {
                x: 426,
                y: 208
            },
            line_17_cell_3: {
                x: 608,
                y: 208
            },
            line_17_cell_4: {
                x: 790,
                y: 308
            },
            line_17_end: {
                x: 959,
                y: 376
            },
            line_17_gap_0: {
                x: 231,
                y: 208
            },
            line_17_gap_1: {
                x: 413,
                y: 208
            },
            line_17_gap_2: {
                x: 595,
                y: 208
            },
            line_17_gap_3: {
                x: 775,
                y: 294
            }
        },
        trajectory: [
            0,
            0,
            0,
            0,
            1
        ]
    },
    {
        chunks: {
            line_18_begin: {
                x: 15,
                y: 560
            },
            line_18_cell_0: {
                x: 62,
                y: 560
            },
            line_18_cell_1: {
                x: 244,
                y: 560
            },
            line_18_cell_2: {
                x: 426,
                y: 560
            },
            line_18_cell_3: {
                x: 608,
                y: 473
            },
            line_18_cell_4: {
                x: 790,
                y: 392
            },
            line_18_end: {
                x: 959,
                y: 392
            },
            line_18_gap_0: {
                x: 231,
                y: 560
            },
            line_18_gap_1: {
                x: 413,
                y: 560
            },
            line_18_gap_2: {
                x: 595,
                y: 560
            },
            line_18_gap_3: {
                x: 777,
                y: 459
            }
        },
        trajectory: [
            2,
            2,
            2,
            2,
            1
        ]
    },
    {
        chunks: {
            line_19_cell_0: {
                x: 63,
                y: 552
            },
            line_19_cell_1: {
                x: 244,
                y: 528
            },
            line_19_cell_2: {
                x: 467,
                y: 416
            },
            line_19_cell_3: {
                x: 608,
                y: 524
            },
            line_19_cell_4: {
                x: 790,
                y: 608
            },
            line_19_end: {
                x: 959,
                y: 608
            },
            line_19_gap_0: {
                x: 231,
                y: 552
            },
            line_19_gap_1: {
                x: 413,
                y: 466
            },
            line_19_gap_2: {
                x: 551,
                y: 466
            },
            line_19_gap_3: {
                x: 777,
                y: 608
            }
        },
        trajectory: [
            2,
            2,
            1,
            2,
            2
        ]
    },
    {
        chunks: {
            line_20_cell_0: {
                x: 63,
                y: 216
            },
            line_20_cell_1: {
                x: 244,
                y: 216
            },
            line_20_cell_2: {
                x: 458,
                y: 297
            },
            line_20_cell_3: {
                x: 608,
                y: 160
            },
            line_20_cell_4: {
                x: 790,
                y: 160
            },
            line_20_end: {
                x: 959,
                y: 160
            },
            line_20_gap_0: {
                x: 231,
                y: 216
            },
            line_20_gap_1: {
                x: 413,
                y: 239
            },
            line_20_gap_2: {
                x: 560,
                y: 243
            },
            line_20_gap_3: {
                x: 777,
                y: 160
            }
        },
        trajectory: [
            0,
            0,
            1,
            0,
            0
        ]
    }
]
};



//////////////////
// WEBPACK FOOTER
// ./cfg/lines-config.js
// module id = 20
// module chunks = 0